export default __webpack_public_path__ + "static/media/nextgen-logo.2c8d1a2a.png";